import { getConfiguration } from '@/api/clients/useApiClient.util.ts';
import { UserDetailsWithPermissionDto, UsersApiFactory } from '@/api/generated';
import { sharedAxiosInstance } from '@/api/useAxiosInstance.util.tsx';
import { CONFIG } from '@/config/config.ts';

let currentUserPromise: Promise<UserDetailsWithPermissionDto> | undefined;

// ponytail: one memoized `me()` call shared by route middleware/lazy guards and
// UserContextProvider's queryFn, so router-level checks don't trigger a second request.
// Cleared on failure so a later attempt can retry.
export const fetchCurrentUser = (): Promise<UserDetailsWithPermissionDto> => {
  currentUserPromise ??= UsersApiFactory(
    getConfiguration(CONFIG.HOST),
    undefined,
    sharedAxiosInstance,
  )
    .me()
    .then(response => response.data);
  currentUserPromise.catch(() => {
    currentUserPromise = undefined;
  });
  return currentUserPromise;
};

/** Drops the memoized `me()` result and fetches it again, e.g. after the signed-in user's own role changed. */
export const refetchCurrentUser = (): Promise<UserDetailsWithPermissionDto> => {
  currentUserPromise = undefined;
  return fetchCurrentUser();
};
